import { SVG } from 'assets/imagePath';
import { Box } from 'components/box';
import Button from 'components/button/Button';
import Footer from 'components/footer/Footer';
import { GridTable } from 'components/gridTable';
import { HeaderApp } from 'components/header';
import Staff from 'components/staffs';
import { DEFAULT_LIMIT } from 'constant/pagination';
import DefaultLayout from 'layouts/DefaultLayout/DefaultLayout';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import { ITableColumn } from 'types';
import { getRowsByPage } from 'utils';
import { fakeColStaff } from './data';

export interface IStaffPageProps {}

export default function StaffPage({}: IStaffPageProps) {
  const fakeColumn: ITableColumn[] = [
    {
      field: 'name',
      headerName: 'Name',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'staff_title',
      headerName: 'Staff Title',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'staff_degree',
      headerName: 'Staff Degree',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'email',
      headerName: 'Email',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'cell',
      headerName: 'Cell',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'locations',
      headerName: 'Locations',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'organization',
      headerName: 'Organization',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'staff_assign',
      headerName: 'Staffing Assignments',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'comment',
      headerName: 'Comments',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },
    {
      field: 'attachments',
      headerName: 'Attachments',
      headerStyle: { textAlign: 'center' },
      rowStyle: {
        justifyContent: 'center'
      }
    },

    {
      field: 'actions',
      headerName: ' ',
      headerStyle: { textAlign: 'center', width: '50px' },
      rowStyle: {
        justifyContent: 'center',
        width: '50px'
      },

      renderCell: (row) => {
        return (
          <>
            <img
              id={`tooltip_plus_${row?.id}`}
              src={SVG.plus}
              alt="co-icon"
              className="icon-app cursor-pointer min-w-[17px]"
              // onClick={() => {
              //   navigate(`/note/${row?.id}`);
              // }}
            />
            <Tooltip anchorId={`tooltip_plus_${row?.id}`} content="Note Detail" />
          </>
        );
      }
    }
  ];
  const [toggle, setToggle] = useState(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_LIMIT);
  const [rows, setRows] = useState(getRowsByPage(fakeColStaff, pageSize, currentPage));

  const handleChangePageSize = (value: number) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const newRows = getRowsByPage(fakeColStaff, pageSize, currentPage);
    setRows(newRows);
  }, [pageSize, currentPage]);

  const form = useForm({
    defaultValues: {},
    mode: 'onChange'
    // resolver: FormResolver(useLoginSchema())
  });

  const handleFilter = (data) => {
    console.log(data);
  };

  return (
    <DefaultLayout>
      <HeaderApp.Inquires toggle={toggle} setToggle={setToggle} />
      <div className="w-full h-full flex flex-col flex-1 items-center  p-2.5">
        <div className="flex items-center justify-between w-full">
          <p className="font-normal">
            Records:
            {/* <span className="font-bold">{pageSize}</span> */}
          </p>
          <div className="px-2.5">
            <Button.White
              className="px-4"
              color="white"
              label="10 Records per page"
              icon={SVG.chevron_down}
              onClick={() => {}}
            />
          </div>
        </div>

        <div className="flex gap-2.5 flex-1 items-stretch h-full w-full mt-2.5">
          <div className={`w-[180px]  transition-all ${toggle ? '' : '-translate-x-[150%] fixed'}`}>
            <FormProvider {...form}>
              <form className="h-full">
                <Staff.Filter
                  onClearFilter={() => form.reset({})}
                  onSubmitFilter={form.handleSubmit(handleFilter)}
                  onClearSearchBox={() =>
                    form.reset((currentValues) => ({ ...currentValues, search_box: '' }))
                  }
                />
              </form>
            </FormProvider>
          </div>
          <div className="relative flex-1 h-full overflow-auto">
            <Box.Standard className="flex flex-col w-full h-full p-0 overflow-auto ">
              <div className="!overflow-auto  w-full max-h-full z-0">
                <GridTable column={fakeColumn} row={rows} />
              </div>
            </Box.Standard>
          </div>
        </div>
      </div>
      <Footer
        pagination={{
          total: fakeColStaff?.length,
          pageSize: pageSize,
          onChangeCurrentPage: handleChangePage,
          onChangePageSize: handleChangePageSize
        }}
      />
    </DefaultLayout>
  );
}
